import BusinessEntity, { EntityManager, EntityManagerParameters } from '@xFrame4/business/base/BusinessEntity';
import { BusinessEntityFieldType } from '@xFrame4/business/base/Constants';
import { ManyToManyCollection } from '@xFrame4/business/base/ManyToManyCollection';
import { BusinessEntityWithTranslation, BusinessEntityTranslation, EntityWithTranslationManager, EntityTranslationManager, EntityWithTranslationManagerParameters } from '@xFrame4/business/base/BusinessEntityWithTranslation';

import RestaurantMenu from '@business/restaurant/RestaurantMenu';


export class RestaurantMenuTranslationGeneratedEntityManager<B extends RestaurantMenuTranslationGenerated> extends EntityTranslationManager<B>
{

    constructor(parameters: EntityManagerParameters<B>)
    {
        super({
            name: parameters.name ?? 'RestaurantMenuTranslation',
            createEntity: parameters.createEntity,
            fields: [
				{ name: 'restaurantMenu', type: BusinessEntityFieldType.ForeignKey, isRequiredInput: true, inputName: 'restaurantMenuId', inputProperty: 'restaurantMenu.id', relatedManager: RestaurantMenu.manager },
				{ name: 'name', type: BusinessEntityFieldType.VarChar, isRequiredInput: true },
				{ name: 'description', type: BusinessEntityFieldType.Text },
                ... parameters.fields ?? [],
            ],
            graphQlQueryAlias: parameters.graphQlQueryAlias ?? 'restaurantMenuTranslations',
        });
    }

}
export class RestaurantMenuTranslationGenerated extends BusinessEntityTranslation
{
	/** The name of the foreign key to the translated entity. */
	translatedEntityForeignKeyName: string = 'restaurantMenu';
	/** The ID of the RestaurantMenu this translation belongs to. */
	restaurantMenu!: RestaurantMenu;
	/** The translated name of the restaurant menu. */
	name!: string;
	/** The translated description of the restaurant menu. */
	description: string = '';

}

export default RestaurantMenuTranslationGenerated;